import { clientApi } from '@/config/axios';

type ExportStatus = { id: string; status: string };

/** Prepare a frozen export, then retrieve its verified PDF when the worker finishes. */
export async function exportDocumentPdf(base: string, versionId: string | null, action: 'print' | 'download') {
  // Open synchronously with the user's click so browsers allow the print tab.
  const tab = action === 'print' ? window.open('about:blank', '_blank') : null;
  if (action === 'print' && !tab) throw new Error('Allow pop-ups to open the printable PDF.');
  if (tab) tab.document.body.textContent = 'Preparing PDF…';

  try {
    const created = await clientApi.post<ExportStatus>(`${base}/exports`, { version_id: versionId });
    const id = created.data.id;
    let status = created.data.status;

    for (let attempt = 0; status !== 'ready' && attempt < 45; attempt++) {
      if (status === 'failed') throw new Error('PDF rendering failed. Try Prepare PDF to view the error and retry.');
      await new Promise((resolve) => setTimeout(resolve, 2000));
      status = (await clientApi.get<ExportStatus>(`${base}/exports/${id}`)).data.status;
    }
    if (status !== 'ready') throw new Error('PDF rendering is taking too long. Try Prepare PDF to check its status.');

    const response = await clientApi.get<Blob>(`${base}/exports/${id}/pdf`, { responseType: 'blob' });
    const url = URL.createObjectURL(response.data);
    if (tab) {
      tab.location.href = url;
    } else {
      const link = document.createElement('a');
      link.href = url;
      link.download = `${versionId ? 'report' : 'draft'}-${id}.pdf`;
      link.click();
    }
    setTimeout(() => URL.revokeObjectURL(url), 300000);
  } catch (error) {
    tab?.close();
    throw error;
  }
}
